<p>{{ '::Loading' | abpLocalization }}...</p>
